import styled from "styled-components";

import { CardContainer } from "features/Strategy/v2/Detail/StrategyDetails.styles";
import { Title } from "style/components/Title.styles";
import { Placeholder } from "components/Placeholder";

const SupportedBrokersPlaceholderContainer = styled.div`
  .icon-wrapper .placeholder-custom {
    height: 50px;
    width: 50px;
    border-radius: 50%;
    margin: 0.5rem;
  }
`;

export const SupportedBrokersPlaceholder = () => {
  return (
    <SupportedBrokersPlaceholderContainer>
      <CardContainer className="secondary supported-brokers">
        <Title className="title mb-4">Supported Brokers</Title>
        <div className="icon-wrapper">
          {Array.from({ length: 8 }, (_, index) => (
            <Placeholder key={index} className="placeholder-custom" />
          ))}
        </div>
      </CardContainer>
      <div className="divider mt-4 mb-0"></div>
    </SupportedBrokersPlaceholderContainer>
  );
};
